const fileCashIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
      <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
        <g stroke="#C9CCCD" stroke-linejoin="round">
          <g transform="translate(9.167 9.167)">
            <circle cx="5.417" cy="5.417" r="5"/>
            <path stroke-linecap="round" d="M.0908333333 4.85C.0908333333 5.49.61 6.00916667 1.25 6.00916667 1.89 6.00916667 2.40916667 5.49 2.40916667 4.85 2.40916667 4.21 1.89 3.68916667 1.25 3.68916667.61 3.68916667.0908333333 3.17166667.0908333333 2.53.0908333333 1.89.61 1.37083333 1.25 1.37083333 1.89 1.37083333 2.40916667 1.89 2.40916667 2.53M1.25 6.00916667L1.25 6.78083333M1.25.599166667L1.25 1.37166667" transform="translate(4.167 1.667)"/>
          </g>
          <g stroke-linecap="round">
            <path d="M2.91666667 5.41666667L6.66666667 5.41666667M2.91666667 7.91666667L9.58333333 7.91666667M2.91666667 10.4166667L7.91666667 10.4166667M2.91666667 12.9166667L7.08333333 12.9166667"/>
            <polyline points="8.75 17.917 .417 17.917 .417 .417 9.583 .417 13.75 4.583 13.75 7.917"/>
            <polyline points="9.583 .417 9.583 4.583 13.75 4.583"/>
          </g>
        </g>
        <rect width="20" height="20"/>
      </g>
    </svg>
`;

export default fileCashIcon;
